document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.before-after-slider').forEach((slider) => {

    const afterImage = slider.querySelector('.after-image');
    const line = slider.querySelector('.slider-line');

    let dragging = false;

    // Початкова позиція
    setPosition(50);

    function setPosition(percent) {

      percent = Math.max(0, Math.min(100, percent));

      afterImage.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;;
      line.style.left = percent + '%';

    }

    function updatePosition(clientX) {

      const rect = slider.getBoundingClientRect();

      const x = clientX - rect.left;

      const percent = (x / rect.width) * 100;

      setPosition(percent);

    }

    // ===== Mouse =====

    slider.addEventListener('mousedown', (e) => {

      dragging = true;
      slider.classList.add('dragging');

      updatePosition(e.clientX);

    });

    window.addEventListener('mousemove', (e) => {

      if (!dragging) return;

      updatePosition(e.clientX);

    });

    window.addEventListener('mouseup', () => {

      dragging = false;
      slider.classList.remove('dragging');

    });

    // ===== Touch =====

    slider.addEventListener('touchstart', (e) => {

      dragging = true;
      slider.classList.add('dragging');

      updatePosition(e.touches[0].clientX);

    }, { passive: true });

    window.addEventListener('touchmove', (e) => {

      if (!dragging) return;

      updatePosition(e.touches[0].clientX);

    }, { passive: true });

    window.addEventListener('touchend', () => {

      dragging = false;
      slider.classList.remove('dragging');

    });

    // ===== Click =====

    slider.addEventListener('click', (e) => {

      if (dragging) return;

      updatePosition(e.clientX);

    });

    // ===== Resize =====

    window.addEventListener('resize', () => {

      const current =
        parseFloat(afterImage.style.width) || 50;

      setPosition(current);

    });

  });

});